// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__3zuSe","breadcrumbLink":"Breadcrumb_breadcrumbLink__38LE_","currentLink":"Breadcrumb_currentLink__2goyS","divider":"Breadcrumb_divider__1poTa"};